import React, { Component } from "react";
// New canvas-based card images
import cardBackImg from '../../images/card-back.png';
import cvsCardBackImg from '../../images/cvs-back.png';

// Legacy imports — kept for reference, no longer used in render
// import RxlogoWhite from '../../images/logo-alt.png';
// import cvs from '../../images/cvs-card.png';
// import wg from '../../images/walgreens.png';
// import wmcvs from '../../images/wallmart-cvs.png';
// import ld from '../../images/longs-drugs.png';
// import ra from '../../images/rite-aid.png';
// import kroger from '../../images/kroger.png';
// import cvsdot from '../../images/cvs-dot.png';
// import wallmart from '../../images/wallmart-card.png';
// import AppleWallet from "../../images/apple-wallet.svg";
// import GoogleWallet from "../../images/google-wallet.svg";
// import AppleModal from "../../components/Consumer/appleModal";
// import Resources from "../../resources.json";
// import { userService } from "../../_services";

class CardBack extends Component {
    constructor(props) {
        super(props);
        this.state = {
            carddata: props.cardData ? props.cardData : {},
            groupdata: props.groupData ? props.groupData : { groupnumber: '' },
            // Device / browser detection kept for potential future wallet re-activation
            passtype: 'generic',
            deviceName: '',
            browserName: '',
            applePopup: false,
            shwoApplePopup: false,
            Primary_Gn: this.props.PrimaryGn,
            applePass: '',
            googlePass: '',
            popupApplePass: '',
            groupNumber: '',
            linkDisabled: false
        };
    }

    componentWillReceiveProps(props) {
        this.setState({
            carddata: props.cardData ? props.cardData : {},
            groupdata: props.groupData ? props.groupData : { groupnumber: '' }
        });
    }

    render() {
        const carddata = this.state.carddata || {};
        const isCvs = carddata.classnames === 'cvs_card';

        return (
            <img
                src={isCvs ? cvsCardBackImg : cardBackImg}
                alt="Prescription Savings Card — Back"
                style={{ height: 'auto', borderRadius: 16, display: 'block' }}
            />
        );

        /* Legacy HTML card markup — replaced by image above
        return (
            <>
                {
                    this.state.carddata && this.state.carddata.classnames === 'cvs_card' ?
                        <>
                            <div className="order_card card_back glic_card">
                                <div className="card_body">
                                    <h3>Exclusive savings at CVS Pharmacy&#174; locations<br />on prescription medications. </h3>
                                    <div className="instructions">
                                        <p><strong>Customer Instructions:</strong> Show this card to your CVS pharmacist to receive savings. For more information, call toll-free to 1-866-978-1084.</p>
                                        <p><strong>Pharmacist Instructions:</strong> This card entitles the cardholder to all prescription benefits associated with the BIN, GRP, and PCN codes. For help processing, please call toll-free at 1-800-974-3135. </p>
                                    </div>
                                    <h4>This card is accepted at <img src={wmcvs} alt="Walmart CVS" /> <img src={cvsdot} alt="CVS Pharmacy" /> <img src={ld} alt="Longs Drugs" /></h4>
                                    <p>Visit <a href="https://singlecare.com/honestdiscounts" target="_blank" style={{ color: '#ce0c2e' }}>singlecare.com/honestdiscounts</a> for more information, pricing and participating pharmacies.</p>
                                    <p>Your privacy is protected. We do not rent or sell your personal information.<br />By using this card you have agreed to the terms and conditions found at singlecare.com/terms-and-conditions. The CVS Pharmacy logo is a trademark and/or registered trademark of CVS Pharmacy and/or one of its affiliates.</p>
                                    <div className="seperator-text"><span>This card is free. This is not insurance</span></div>
                                </div>
                                <div className="card-footer">
                                    <div className="right_info">
                                        <span>&copy; 2019 SingleCare Administrators</span>
                                        <span>SCHD_0819_CVS_CA</span>
                                    </div>
                                    <div className="instructions">
                                        <h4>Pharmacist Instructions</h4> <p>This card is preactivated and gives member discounts through the BIN. PCN, GROUP on the front If you need assistance, call 811-800-7820</p>
                                    </div>
                                </div>
                            </div>
                        </> :
                        <>{this.state.carddata && this.state.carddata.classnames === 'walmart_card' ?
                            <>
                                <div className="order_card card_back glic_card">
                                    <div className="card_body">
                                        <h3>Available savings at Walmart pharmacies<br />on FDA-approved prescription medications.*</h3>
                                        <div className="instructions">
                                            <p><strong>Customer Instructions:</strong> Show this card to your Walmart pharmacist to receive savings. For more information, call toll-free at 1-866-978-1091.</p>
                                            <p><strong>Pharmacist Instructions:</strong> This card entitles the cardholder to all prescription benefits associated with the BIN, GRP, and PCN codes. For help processing, please call toll-free at 1-800-974-3135.</p>
                                        </div>
                                        <h4>This card is accepted at <img src={wallmart} alt="Walmart" style={{ maxHeight: '15px', marginBottom: '-3.5px' }} /></h4>
                                        <p>Visit <a href="https://singlecare.com/honestdiscounts" target="_blank" style={{ color: '#1e76d0' }}>singlecare.com/honestdiscounts</a> for more information, pricing and participating pharmacies.</p>
                                        <p>This card is not insurance.<br />Your privacy is protected. We do not rent or sell your personal information.<br />By using this card you have agreed to the terms and conditions found at singlecare.com/terms-and-conditions.</p>
                                        <div className="walmart_info">
                                            <span>*Subject to pharmacist discretion</span>
                                            <span>&copy; 2019 SingleCare Administrators</span>
                                            <span>SCHD_0819_WM_CA</span>
                                        </div>
                                    </div>
                                </div>
                            </> :
                            <>
                                <div className="order_card card_back glic_card">
                                    <div className="card_back_logo">
                                        <img src={RxlogoWhite} className="img-fluid card_logo" alt="NuLifeSpan Rx Logo" />
                                    </div>
                                    <div className="card_body">
                                        <div className="left_info">
                                            <div className="col-6">
                                                <strong>Member Instructions</strong><br />
                                                2. Ask for discount on each prescription.<br />
                                                3. SAVE UP TO 80%*<br />
                                                1. Present card to your pharmacist.<br />
                                                4. Use over and over! This card does not expire.
                                            </div>
                                            <div className="col-6">
                                                <strong>Instrucciones Miembros</strong><br />
                                                2. Pedir descuento en cada receta.<br />
                                                3. AHORRE HASTA UN 80%**<br />
                                                1. Presente la tarjeta a su farmacéutico.<br />
                                                4. ¡Utilice una y otra vez! Esta tarjeta no caduca.
                                            </div>
                                            <div className="col-12">
                                                <p>*Prescription savings vary by prescription and by pharmacy, and may reach up to 80% off the cash price. **Los ahorros en recetas varían según la receta y la farmacia, y pueden alcanzar hasta un 80% de descuento sobre el precio en efectivo.</p>
                                                <p>Visit NuLifeSpanRx.com or call 800-984-4031 for more information to report any concerns and find participating pharmacies near you! The NuLifeSpanRx Program prices, list of covered drugs, and participating pharmacies are subject to change. By using this card, you have agreed to the terms &amp; conditions found at nulifespanrx.com/terms. Purchases do not count towards insurance or Medicare deductibles or out-of-pocket maximums.</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="card-footer">
                                        <div className="seperator-text" style={{ width: '100%' }}><span>This card is free. This is not insurance.</span></div>
                                        <div className="logos">
                                            <img src={cvs} alt="CVS Pharmacy" />
                                            <img src={wg} alt="Walgreens" />
                                            <img src={ra} alt="Rite Aid" />
                                            <img src={kroger} alt="Kroger" />
                                            <img src={wallmart} alt="Walmart" />
                                        </div>
                                        <div className="right_info">
                                            {
                                                this.props.isLinked ?
                                                    <div>
                                                        <p>
                                                            <strong>www.NuLifeSpanRX.com</strong><strong>2018-2026</strong>
                                                        </p>
                                                    </div> :
                                                    <div>
                                                        <p>
                                                            <a href="https://nulifespanrx.com/" target="_blank" className="no-styling"><strong>www.NuLifeSpanRX.com</strong></a><strong>2018-2026</strong>
                                                        </p>
                                                    </div>
                                            }
                                        </div>
                                        <div className="instructions">
                                            Pharmacist Instructions: This card is preactivated and gives member discounts through the BIN, PCN, GROUP on the front. If you need assistance, call 877-800-7820 CVS, Walgreens, Rite Aid, Kroger, and Walmart logos are trademarks of CVS, Walgreens, Rite Aid, Kroger, and Walmart Respectively.
                                        </div>
                                    </div>
                                </div>
                            </>
                        }</>
                }
                // Apple Wallet modal — commented for future use
                // {
                //     this.state.applePopup ? <AppleModal applePass={this.state.popupApplePass} closeModal={this.closeAppleWalletPopup.bind(this)} /> : null
                // }
            </>
        )
        */
    }
}
export default CardBack;
